'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var cx = require('classnames');
var alloyProductCards_module = require('./alloy-product-cards.module.scss.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var cx__default = /*#__PURE__*/_interopDefault(cx);

/**
 * This component has been deprecated. Please see <Card>
 * @deprecated
 */
var CardManager = function (_a) {
    var _b;
    var children = _a.children, variant = _a.variant, className = _a.className, props = tslib.__rest(_a, ["children", "variant", "className"]);
    return (jsxRuntime.jsx("div", tslib.__assign({ "data-testid": "card-manager", className: cx__default.default("".concat(alloyProductCards_module.default['prod-card']), (_b = {},
            _b["".concat(alloyProductCards_module.default['cursor-pointer'])] = !!props.onClick,
            _b[" ".concat(alloyProductCards_module.default[variant])] = variant,
            _b), className) }, props, { children: Array.isArray(children)
            ? children.map(function (child, index) {
                return react.cloneElement(child, {
                    key: index,
                    variant: variant
                });
            })
            : react.cloneElement(children, {
                variant: variant
            }) })));
};

exports.CardManager = CardManager;
//# sourceMappingURL=CardManager.js.map
